var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 28.5222L40.0131 2.80566L77.2869 28.5222L40.0131 49.1028L2.40625 28.5222Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0145 28.641L39.9994 1.72363L0.985352 28.641V77.1219C0.985352 77.4319 1.04451 77.7389 1.15941 78.0253C1.27432 78.3116 1.44271 78.5718 1.65501 78.791C1.86732 79.0101 2.11936 79.1839 2.39673 79.3025C2.6741 79.421 2.97137 79.4819 3.27155 79.4818H76.7322C77.3383 79.4818 77.9196 79.2332 78.3481 78.7906C78.7767 78.348 79.0174 77.7478 79.0174 77.1219L79.0145 28.641Z",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2002 49.8994L37.9185 55.0364C38.5627 55.3771 39.276 55.5547 39.9997 55.5547C40.7234 55.5547 41.4368 55.3771 42.0809 55.0364L51.7992 49.8994",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9722 39.0817V23.2881H20.0278L19.1094 37.9684L39.6831 49.142",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9722 39.0817V23.2881H20.0278L19.1094 37.9684L39.6831 49.142",
    stroke: "#386BFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.707 30.7383H51.2911",
    stroke: "#386BFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.707 36.8672H51.2911",
    stroke: "#386BFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0145 28.6406L39.9994 49.269L0.985352 28.6447",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1adce0ad27cf0f7e608e8a024e87c9b9.svg";
export { ForwardRef as ReactComponent };